import Vue from 'vue'

import {mapGetters} from 'vuex'
import CardImg from 'assets/images/card.png'

import template from './index.pug'

export default Vue.extend({
  name: 'news-page',
  template: template(),
  data() {
    return {
      news: [],
      deltaTabIndex: 100,
      cardImg:CardImg
    }
  },

  computed: {
    slug() {
      return this.$route.params.slug
    }
  },

  watch: {
    slug() {
    }
  },

  created() {
  },

  methods: {
    
  }
})
